<p-confirmDialog key="stationblockalertassignmenthomeroom" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div>
	<p-table
		#mydt
		[value]="lstTable"
		[loading]="IsLoading() == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="lstSelected"
		dataKey="HomeroomID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--Homeroom-->
				<th>
					<p-columnFilter type="text" field="Homeroom" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StudentCount-->
				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="Homeroom">Homeroom<p-sortIcon field="Homeroom"></p-sortIcon></th>
				<th pSortableColumn="StudentCount">Student Count<p-sortIcon field="StudentCount"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Homeroom>
			<tr [pSelectableRow]="Homeroom">
				<td>
					<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="Homeroom" [value]="Homeroom"></p-tableCheckbox>
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Homeroom.Homeroom }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Homeroom.StudentCount }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<div class="TopMargin" *ngIf="warningMessage">
	<div name="warningMessage" class="alert alert-warning">{{ warningMessage }}</div>
</div>

<div class="TopMargin" *ngIf="errorMessage">
	<div name="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
